import { DISCONTINUED_PREREQUISITE_VALUE, PrerequisiteExistenceStatus } from '../enums/prerequisite-type.enum';

export const isDiscontinuedPrerequisite = (existenceStatus: PrerequisiteExistenceStatus | undefined) =>
  existenceStatus === PrerequisiteExistenceStatus.DISCONTINUED;

export const toPrerequisitePayload = <T extends { prerequisiteId?: number | null }>(params: T): T =>
  params?.prerequisiteId === DISCONTINUED_PREREQUISITE_VALUE ? { ...params, prerequisiteId: null } : params;

export const prerequisiteMatchKey = (item: { prerequisiteId?: number | null; prerequisiteCode?: string | null }): string =>
  item.prerequisiteId !== null && item.prerequisiteId !== undefined ? `id:${item.prerequisiteId}` : `discontinued:${item.prerequisiteCode ?? ''}`;
